export default "__VITE_ASSET__DcXO7egF__"